import { useEffect, useState } from 'react';
import { QuickstartCard } from './QuickstartCard';
import { QuickstartTheme } from '../types/theme';

interface QuickstartLoadingProps {
  theme: QuickstartTheme;
  message?: string;
}

const loadingMessages = [
  'Searching for available machine...',
  'Authenticating credentials...',
  'Establishing secure link...',
  'Synchronizing broadcast data...',
  'Allocating system resources...',
  'Optimizing connection parameters...',
  'Finalizing environment setup...',
  'Verifying runtime integrity...',
  'Preparing broadcast handshake...',
  'Stabilizing connection...',
  'Performing system checks...',
  'Balancing server load...',
  'Negotiating protocols...',
  'Confirming network stability...',
  'Validating broadcast tokens...',
];

export const QuickstartLoading = ({ theme, message }: QuickstartLoadingProps) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    // If a custom message is provided, don't cycle
    if (message) return;

    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;

        // If we've reached the end of the list
        if (nextIndex >= loadingMessages.length) {
          // Skip the first message on subsequent cycles
          return 1;
        }

        return nextIndex;
      });
    }, 8000); // Change message every 8 seconds

    return () => clearInterval(interval);
  }, [message]);

  const displayMessage = message || loadingMessages[currentMessageIndex];

  return (
    <div
      className='flex min-h-screen items-center justify-center overflow-auto p-4'
      style={{
        backgroundImage: theme.pageBackgroundImage ? `url(${theme.pageBackgroundImage})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <QuickstartCard theme={theme} badgeOverride="SNEAK PEEK">
        <div className='flex flex-col items-center space-y-6'>
          {/* Loading Spinner */}
          <div
            className='h-16 w-16 animate-spin rounded-full border-4 border-transparent'
            style={{
              borderTopColor: theme.spinnerColor || theme.primaryColor,
              borderRightColor: theme.spinnerColor || theme.primaryColor,
            }}
          />

          {/* Message */}
          <p className='max-w-[200px] text-center text-base h-12 flex items-center justify-center' style={{ color: '#FEF3C7' }}>
            {displayMessage}
          </p>
        </div>
      </QuickstartCard>
    </div>
  );
};

